/**
 * Firestore collection names for painttheworld.
 *
 * All collections are namespaced under 'ptw-' so the Firebase project
 * can be shared across multiple games without collection name collisions.
 */
const PTW = 'ptw';

export const COLLECTIONS = {
  TILES: `${PTW}-tiles`,
  USERS: `${PTW}-users`,
  COLOR_COUNTS: `${PTW}-colorCounts`,
  OVERTAKE_THROTTLES: `${PTW}-overtakeThrottles`,
  PAINT_BUCKETS: `${PTW}-paintBuckets`,
  CURRENCY: `${PTW}-currency`,
  /** Player engagement stats per user */
  PLAYER_STATS: `${PTW}-playerStats`,
  /** Server-side config documents */
  CONFIG: `${PTW}-config`,
  /** Pre-aggregated grid cells at ~1.1km resolution (0.01°) for zoom 8–12 */
  GRID_CELLS_FINE: `${PTW}-cells-fine`,
  /** Pre-aggregated grid cells at ~11km resolution (0.1°) for zoom 0–8 */
  GRID_CELLS_COARSE: `${PTW}-cells-coarse`,
  /** Player-planted map messages — one doc per user, keyed by uid */
  MESSAGES: `${PTW}-messages`,
  /** Community forum threads */
  FORUM_THREADS: `${PTW}-forum-threads`,
  /** Per-thread replies subcollection name (under a forum thread doc) */
  FORUM_REPLIES: 'replies',
  /** Forum author rate-limit state — one doc per user, keyed by uid */
  FORUM_AUTHORS: `${PTW}-forum-authors`,
} as const;

export type CollectionName = (typeof COLLECTIONS)[keyof typeof COLLECTIONS];
